const PINOT_START_TIMESTAMP = 1703980800000;
export const SUPPORTED_EARLY_REQUEST_PARAMS = ['insightContext', 'emailStartDate'];

// Params

const stringifySearchParams = (params = {}) => {
  return Object.entries(params).filter(([__, value]) => value !== '' && value !== null && value !== undefined).map(([key, value]) => `${key}=${value}`).join('&');
};
const parseSearchParams = (params = '') => {
  return params.replace('?', '').split('&').reduce((acc, param) => {
    const [key, value] = param.split('=');
    acc[key] = value;
    return acc;
  }, {});
};
const filterSupportedParams = search => {
  const parsedParams = parseSearchParams(search);
  const supported = Object.fromEntries(Object.entries(parsedParams).filter(([key]) => SUPPORTED_EARLY_REQUEST_PARAMS.includes(key)));
  const additional = Object.fromEntries(Object.entries(parsedParams).filter(([key]) => !SUPPORTED_EARLY_REQUEST_PARAMS.includes(key)));
  return {
    supported,
    additional
  };
};
export const getSearchParams = search => {
  const {
    supported: {
      emailStartDate: emailPublishDate
    },
    additional: paramsObject
  } = filterSupportedParams(search);
  const params = stringifySearchParams(paramsObject);
  return {
    emailPublishDate,
    params
  };
};

// Early Request key

const getSortedCopy = input => {
  const copy = [...input];
  copy.sort((a, b) => {
    if (Array.isArray(a) && Array.isArray(b)) {
      return String(a[0]).localeCompare(String(b[0]));
    }
    return String(a).localeCompare(String(b));
  });
  return copy;
};

// Serializes the input object into a string containing all keys and values delimited by '_'
// Keys and arrays are sorted alphabetically, and empty values are ignored
// Nested objects are serialized recursively
// Example:
// input -
// {
//   outerObj: {
//     innerObj: {
//       key2: 'value2',
//       key1: ['value1.2', 'value1.1'],
//     },
//     nullKey: null,
//     undefinedKey: undefined,
//     emptyStringKey: '',
//     a: 'z',
//   },
// };
// output - outerObj_a_z_innerObj_key1_value1.1,value1.2_key2_value2
export const buildEarlyRequestKey = input => {
  if (input === null || input === undefined || typeof input === 'function') {
    return '';
  }
  if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return String(input);
  }
  if (Array.isArray(input)) {
    return getSortedCopy(input).map(val => buildEarlyRequestKey(val)).join(',');
  }
  if (typeof input === 'object') {
    return getSortedCopy(Object.entries(input)).map(([key, value]) => [key, buildEarlyRequestKey(value)]).filter(([__, innerEarlyRequestValue]) => innerEarlyRequestValue !== '').map(([key, innerEarlyRequestValue]) => `${key}_${innerEarlyRequestValue}`).join('_');
  }
  return '';
};

// Pinot Stats

// Pinot endpoint (bot engagement stats) is only called if
// the email was created after 31-Dec-2023.
export const shouldEarlyRequestPinotStats = emailCreatedDate => !!emailCreatedDate && !isNaN(Number(emailCreatedDate)) && Number(emailCreatedDate) > PINOT_START_TIMESTAMP;
const maybeAddTrailingZero = num => String(num).padStart(2, '0');
export const formatPinotStatsDate = date => {
  // Using UTC timestamps for this as otherwise we may end up passing
  // wrong date based on user timezone
  const dateObj = new Date(date);
  return `${dateObj.getUTCFullYear()}${maybeAddTrailingZero(dateObj.getUTCMonth() + 1)}${maybeAddTrailingZero(dateObj.getUTCDate())}`;
};
export const getPinotStatsFiltersFromDetailsResponse = emailDetails => {
  var _emailDetails$emailCa;
  const {
    primaryEmail,
    primaryEmailId
  } = emailDetails;
  if (!shouldEarlyRequestPinotStats(primaryEmail.created)) {
    return null;
  }
  switch (primaryEmail.emailType) {
    case 'AUTOMATED_EMAIL':
      if (!(emailDetails !== null && emailDetails !== void 0 && (_emailDetails$emailCa = emailDetails.emailCampaign) !== null && _emailDetails$emailCa !== void 0 && _emailDetails$emailCa.apiEmailCampaignGroupId)) {
        return null;
      }
      return {
        startDate: formatPinotStatsDate(Number(primaryEmail.created)),
        endDate: formatPinotStatsDate(Date.now()),
        campaignIdentifier: {
          contentId: Number(primaryEmailId),
          campaignGroupId: emailDetails.emailCampaign.apiEmailCampaignGroupId
        },
        filters: {
          listInclusionIds: []
        }
      };
    default:
      return null;
  }
};